import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = 'membership/running-dashboard'

const runningDashboardEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchRunningDashboards: builder.query<any, void>({
    query: () => ({
      url: basePath,
      method: 'get',
    }),
    providesTags: ['running-dashboard'],
  }),

  fetchRunningDashboardById: builder.query<any, number | string>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'get',
    }),
    providesTags: ['running-dashboard'],
  }),

  createRunningDashboard: builder.mutation<any, any>({
    query: (body) => ({
      url: basePath,
      method: 'post',
      body,
    }),
    invalidatesTags: ['running-dashboard'],
  }),

  updateRunningDashboard: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['running-dashboard'],
  }),

  deleteRunningDashboard: builder.mutation<any, number>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['running-dashboard'],
  }),
})

export default runningDashboardEndpoints
